import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import Chip from '@clds/chip';
import { Icon } from '@cld/icon';
import { theme } from '../FieldBase/FieldBaseTheme';

const chipLayoutStyle = css`
  > * {
    margin-left: ${globalTheme.spacing.xs};
    margin-bottom: ${globalTheme.spacing.xs};
  }
`;

export const NormalChildrenWrapper = styled.div<{
  height: number;
  isHidden: boolean;
}>`
  display: flex;
  overflow: hidden;
  flex-wrap: wrap;
  ${chipLayoutStyle};

  height: ${(props) => props.height}px;

  ${(props) =>
    props.isHidden &&
    css`
      background-color: ${theme.background.color};
      pointer-events: none;
      visibility: hidden;
    `};

  &:empty {
    display: none;
  }
`;

export const ExpandedChildrenWrapper = styled.div<{ width?: number }>`
  position: absolute;
  overflow: hidden;
  display: flex;
  align-self: flex-start;
  flex-wrap: wrap;
  // fixes issue with safari incorrectly rendering svg layer
  z-index: 1;
  ${chipLayoutStyle};

  padding-top: calc(${globalTheme.spacing.xs} - 1px);
  background-color: ${theme.background.color};
  border-radius: ${theme.border.radius};
  box-shadow: 0 0 0 1pt ${theme.border.color.focus};

  width: ${(props) => props.width}px;
`;

const ReadMoreChip = styled(Chip)`
  align-items: center;
  padding-left: ${globalTheme.spacing.sm};
  padding-right: ${globalTheme.spacing.sm};
`;

export interface MoreButtonProps {
  expanded: boolean;
  onClick: () => void;
}

export const MoreButton: FC<React.PropsWithChildren<MoreButtonProps>> = ({ expanded, onClick }) => (
  <ReadMoreChip
    label={
      <>
        &#8203;{/* Zero-width white space is required to maintain correct line height */}
        <Icon size="sm" name={expanded ? 'keyboardArrowUp' : 'moreHorizontal'} />
      </>
    }
    rootProps={{ onClick }}
  />
);
